import { render, staticRenderFns } from "./LibSectionDesc.vue?vue&type=template&id=bda71d00"
import script from "./LibSectionDesc.vue?vue&type=script&lang=js"
export * from "./LibSectionDesc.vue?vue&type=script&lang=js"
import style0 from "./LibSectionDesc.vue?vue&type=style&index=0&id=bda71d00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports